import React, { useContext, useEffect, useState } from "react";
import "../Components/Tickets/Tickets.css";
import { techappContext } from "../../Api/techappReq";
import Loading from "../Components/loading";
import Empty from "../Components/empty";
import loadingSvg from "../../assets/images/loadingSvg.svg";
import loadMoreIcon from "../../assets/images/collapse-close.png";
import AnnouncementCard from "../Components/announcement_card";

const PvMessages = () => {
  const [currentPage, setCurrentPage] = useState(1);

  const {
    getMessages,
    announcements,
    getBadgesReq,
    totalPage,
    loading,
    paginateLoading,
  } = useContext(techappContext);

  useEffect(() => {
    getMessages("private", 1);
    getBadgesReq();
    setCurrentPage(1);
  }, []);

  return (
    <>
      {/* loading */}
      {loading && <Loading title={"در حال بارگذاری اعلان ها"} />}
      {/* view list */}
      {!loading &&
        announcements?.privates?.length > 0 &&
        announcements?.privates?.map((announcement, index) => (
          <AnnouncementCard key={index} announcement={announcement} index={index} />
        ))}
      {/* pagination loading */}
      {!loading &&
        announcements?.privates?.length > 0 &&
        currentPage < totalPage &&
        paginateLoading && (
          <img
            style={{ width: "40px", margin: "15px 0 10px 0" }}
            src={loadingSvg}
            alt="loading"
          />
        )}
      {/* load more */}
      {!loading &&
        announcements?.privates?.length > 0 &&
        currentPage < totalPage &&
        !paginateLoading && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              margin: "15px 0 10px 0",
            }}
            onClick={() => {
              getMessages("private", currentPage + 1);
              setCurrentPage(currentPage + 1);
            }}
          >
            <span style={{ fontSize: "12px" }}>موارد بیشتر</span>
            <img
              src={loadMoreIcon}
              style={{ width: "16px", marginRight: "5px" }}
              alt="load more"
            />
          </div>
        )}
      {/* empty */}
      {!loading && announcements?.privates?.length === 0 && (
        <Empty title={"اعلانی یافت نشد."} />
      )}
    </>
  );
};
export default PvMessages;
